import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, Button, Divider, Typography } from "@material-ui/core";
import { Add, Replay } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import ProgramDirectorInsertModal from "../ProgramDirectorInsertModal";

import { getAllProject } from "../../../reducer/project/action";
import {
  getAllProgramDirector,
  getAllProgramDirectorByProfileId,
  getFilteredProgramDirector,
} from "../../../reducer/programDirector/action";

function ProgramDirectorButton(props) {
  const { getAllProgramDirector, getAllProgramDirectorByProfileId, getFilteredProgramDirector } = props;

  const [inserting, setInserting] = useState(false);

  let profileId = props.selectedProfileId;
  if (!profileId) profileId = props.profileDetail?.id;

  useEffect(() => {
    if (props.type !== "all" && profileId) getAllProgramDirectorByProfileId(profileId);
    return false;
  }, []);

  useEffect(() => {
    if (props.type === "all" && props.listFilteredProgramDirector.length === 0 && !props.isFetching)
      getFilteredProgramDirector(1, -1, { departmentId: props.department });
  }, []);

  useEffect(() => {
    if (props.type === "all" && !props.isFetching && !props.isFetchingAccepted)
      getFilteredProgramDirector(1, -1, { departmentId: props.department });
  }, [props.department, getFilteredProgramDirector]);

  const handleReload = () => {
    if (props.type !== "all") {
      if (profileId) {
        getAllProgramDirectorByProfileId(profileId);
        props.handleReload();
      }
    } else {
      getFilteredProgramDirector(1, -1, { departmentId: props.department });
      props.handleReload();
    }
  };
  const handleInsert = () => setInserting(true);

  return (
    <>
      <Grid container>
        <Grid item xs={6}>
          <Typography variant="h5" style={{ lineHeight: "36px" }}>
            Chương trình cấp quốc gia
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <div style={{ float: "right" }}>
            <Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
              Tải lại
            </Button>
            {props.type !== "all" && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                style={{ marginLeft: 8 }}
                onClick={handleInsert}
              >
                Thêm
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
      <Divider style={{ margin: "8px 0" }} />
      <ProgramDirectorInsertModal inserting={inserting} setInserting={setInserting} />
    </>
  );
}

const mapStateToProps = (state) => ({
  // isFetching: select(state, 'projectReducer', 'isFetching'),
  // isFetchingAccepted: select(state, 'projectReducer', 'isFetchingAccepted'),

  profileDetail: select(state, "profileReducer", "detail"),
  listProgramDirectorById: select(state, "programDirectorReducer", "listById"),
  listFilteredProgramDirector: select(state, "programDirectorReducer", "listFiltered"),
});

const mapDispatchToProps = (dispatch) => ({
  getAllProgramDirectorByProfileId: (id) => dispatch(getAllProgramDirectorByProfileId(id)),
  getFilteredProgramDirector: (page, pageSize, payload) =>
    dispatch(getFilteredProgramDirector(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ProgramDirectorButton));

